module.exports = __webpack_public_path__ + "files/20e93a5e8456bc3beb1b388017df9c79.png";